<template>
    <div class="container">
        <div class="main-box">
            <img src="../assets/images/three-one.png" alt="" class="three-one" />
            <img src="../assets/images/three-two.png" alt="" class="three-two" />
            <div class="tab-list">
                <div class="tab-item color-a" @click="knowledgeA">认知效能</div>
                <div class="tab-item color-b" @click="knowledgeB">和谐家庭</div>
                <div class="tab-item color-c" @click="knowledgeC">美好生活</div>
                <div class="tab-item color-d" @click="knowledgeD">自我认知</div>
                <div class="tab-item color-e" @click="knowledgeE">稳定情绪</div>
                <div class="tab-item color-f" @click="knowledgeF">身心健康</div>
            </div>
        </div>
    </div>    
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {},
    methods: {
        knowledgeA() {
            this.$router.push("/knowledge-a");
        },
        knowledgeB() {
            this.$router.push("/knowledge-b");
        },
        knowledgeC() {
            this.$router.push("/knowledge-c");
        },
        knowledgeD() {
            this.$router.push("/knowledge-d");
        },
        knowledgeE() {
            this.$router.push("/knowledge-e");
        },
        knowledgeF() {
            this.$router.push("/knowledge-f");
        },
    },
    created() {},
};
</script>
<style lang='less' scoped>
.container{
    padding: 160px 30px 40px 30px;
}
.knowledge-content {
    padding: 16px;
}
.main-box {
    background-color: #fff;
    border-radius: 10px;
    padding: 30px 30px 15px 30px;
    position: relative;
}
.three-one {
    display: block;
    height: 180px;
    position: absolute;
    top: -160px;
    right: -30px;
}
.three-two {
    display: block;
    height: 100px;
    position: absolute;
    top: -100px;
    left: -15px;
}
.tab-item {
    height: 50px;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 22px;
    font-weight: 300;
    margin-bottom: 20px;
}
.color-a {
    background-image: linear-gradient(to right, #2e6ef8, #6c5de6);
    box-shadow: 0px 0px 5px 5px #b7b2e9;
}
.color-b {
    background-image: linear-gradient(to right, #ffc452, #e78f11);
    box-shadow: 0px 0px 5px 5px #f5cc91;
}
.color-c {
    background-image: linear-gradient(to right, #17c18b, #029a43);
    box-shadow: 0px 0px 5px 5px #88cfa7;
}
.color-d {
    background-image: linear-gradient(to right, #4c7df8, #0065cc);
    box-shadow: 0px 0px 5px 5px #9dbbe4;
}
.color-e {
    background-image: linear-gradient(to right, #32c3c8, #2b9c98);
    box-shadow: 0px 0px 5px 5px #95d0d8;
}
.color-f {
    background-image: linear-gradient(to right, #8c64ce, #6c5de6);
    box-shadow: 0px 0px 5px 5px #c5a0e7;
}
.knowledge-item {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    border-radius: 20px;
    background-color: #01d6d6;
    margin-bottom: 10px;
}
</style>